import React, { useState } from 'react';
import './FAQ.css';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How fast is delivery?',
      answer: 'Keys are delivered instantly after payment confirmation. Usually within 30 seconds.'
    },
    {
      question: 'Will I get banned?',
      answer: "We update our cheats regularly to stay undetected. While no cheat is 100% safe, we prioritize security and have a strong track record. Don't rage and use smart settings."
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept all major payment methods including credit cards, PayPal, and cryptocurrency through our secure payment processor.'
    },
    {
      question: 'Do you offer refunds?',
      answer: 'Refunds are handled on a case-by-case basis at our discretion. Contact us on Discord within 24 hours if you experience technical issues.'
    },
    {
      question: 'How do updates work?',
      answer: 'All updates are free and automatic. When a game patches, we update the cheat and you get access immediately.'
    },
    {
      question: 'Can I use this on multiple PCs?',
      answer: 'Keys are typically locked to one HWID. If you need to change PCs, contact support on Discord for a reset.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="section faq" id="faq">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Common Questions</h2>
          <p className="section-subtitle">Quick answers to things you might be wondering</p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
